import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { CostComparison } from './components/CostComparison';
import { Visualization } from './components/Visualization';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { EmotionalClose } from './components/EmotionalClose';
import { LegalNotice } from './components/LegalNotice';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { PRICE_VALUE } from './components/Shared';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="23u9v6r043jyv">
    <p className="text-xl font-extrabold italic leading-relaxed text-blue-900/85 md:text-3xl" data-id="element-1" data-mp="3ijxoypkvdyjd">
      🌿 YOUR NEXT SESSION CAN BEGIN WITH CLARITY — NOT DOUBT.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    document.title = 'Biodecoding Practitioner Kit™ | Lumen Akasha™';
    document.documentElement.lang = 'en';
    const description = 'A complete professional toolkit of session frameworks, integration practices, guided questions, and practitioner resources. 3 Core Volumes + 5 Bonuses · 245+ pages for US$25.';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Biodecoding Practitioner Kit',
      content_type: 'product',
      value: PRICE_VALUE,
      currency: 'USD'
    });
  }, []);
  return <div className="min-h-screen w-full bg-stone-50 font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-2" data-mp="35gkz19r83iz">
      <UrgencyBanner data-id="element-3" data-mp="3uc9inv5c9kir" />
      <main data-id="element-4" data-mp="3uf5ijp0qyj9u">
        <Hero data-id="element-5" data-mp="d4nv7fl6zi1v" />
        <PackContents data-id="element-6" data-mp="d57h17dyqql6" />
        <InitialTestimonials data-id="element-7" data-mp="d3mil6oj2ni1" />
        <PainPoints data-id="element-8" data-mp="d2l9v8uzid3h" />
        <Visualization data-id="element-9" data-mp="85l30vqb96bb" />
        <LaunchOffer data-id="element-10" data-mp="851hl51gbzsj" />
        <MoreTestimonials data-id="element-11" data-mp="86w76wno4g2y" />
        <FAQ data-id="element-12" data-mp="83i2hhrj7usc" />
        <CostComparison data-id="element-13" data-mp="83qdt580as1f" />
        <TransitionPhrase data-id="element-14" data-mp="3gkv2dw2tfxfe" />
        <EmotionalClose data-id="element-15" data-mp="3gm665vw9h56i" />
        <LegalNotice data-id="element-16" data-mp="3gja5w0wxy4ew" />
      </main>
      <Footer data-id="element-17" data-mp="3bmjrrj4p5iw4" />
      <FloatingNotification data-id="element-18" data-mp="3bn2zk70muqwf" />
    </div>;
}